<template>
  <div class="layout-notice-card">
    <div class="user-header" ref="userHeader">
      <div class="time">
        <span>{{ currentDate }}</span>
        <span class="line time-line"></span>
        <span>{{currentDay}}</span></div>
      <div class="avatar-row">
        <div class="name">{{ userName ? userName + '，' : '' }}</div>
        <div>{{ digitalHuman.greetings }}</div>
      </div>
      <div class="user-slogan user-slogan-two-line" v-html="slogan"></div>
      <div class="apply-box">
        <div class="apply-btn" @click="handleApplyClick">新建申请</div>
        <!-- <div class="line apply-line"></div> -->
        <div class="refresh-btn" @click="handleRefresh">
          <i class="layout layout-refresh"></i>
          <span>刷新</span>
        </div>
      </div>
      <DigitalHuman v-show="digitalHuman.show" class="digital-human-wrap" :code="digitalHuman.code" :enableClick="digitalHuman.enableClick"/>
      <div v-if="isTest" class="switch-digital-human" @click="switchDigitalHuman">切换</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import mixins from 'public/mixins'
  import DigitalHuman from './digital-human.vue'
  import { ENV } from 'public/config'
  // import hideImg from './images/hide-eye.svg'
  // import showImg from './images/show-eye.svg'
  // import ziBg from './images/zi-bg.png'
  // import lanBg from './images/lan-bg.png'
  // import huiBg from './images/hui-bg.png'
  // import lvBg from './images/lv-bg.png'
  // import hongBg from './images/hong-bg.png'
  // const THEME_IMG_MAP = {
  //   '#894fd5': ziBg, // 紫色
  //   '#2a67e6': lanBg, // 蓝色
  //   '#0fc26d': lvBg, // 绿色
  //   '#f74c4c': hongBg, // 红色
  //   '#3d495a': huiBg, // 灰色
  // }

  export default {
    components: {
      DigitalHuman
    },
    mixins: [mixins],
    data () {
      return {
        currentDate: moment().format('YYYY-MM-DD'),
        currentDay: moment().format('dddd'),
        // hideImg,
        // showImg,
        // visible: true,
        // list: [],
        slogan: '',
        digitalHuman: { // 数字人相关
          timer: null,
          code: '',
          show: false,
          enableClick: false, // 是否启用点击效果
          greetings: this.getTimePeriodText(),
        },
        // unReadNum: 0,
        // themeColor: '#894fd5',
        isTest: ENV !== 'prd'
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      avatar () {
        return this.$store.state.avatar
      },
      userName () {
        return (this.user.name || '').replace(/[0-9]/ig, '')
      },
      humanMaterialList () {
        return this.lookUpOptions['sys_digital_human_material_list'] || []
      }
    },
    watch: {
      $route: {
        handler (val) {
          clearInterval(this.digitalHuman.timer)
          this.digitalHuman.timer = null
          if (val.path === '/') {
            this.init()
            this.digitalHuman.timer = setInterval(this.pollDigitalHuman, 5 * 60 * 1000)
            // this.digitalHuman.timer = setInterval(this.pollDigitalHuman, 5 * 1000)
          }
        },
        immediate: true
      }
    },
    // 防止其他页面刷新导致数据丢失
    // activated () {
    //   this.$bus.$once('OA_NOTICE_TO_HOME', this.getNoticeList)
    //   this.init()
    // },
    mounted () {
      this.mouseXY = ''
      this.oldMouseXY = ''
      window.addEventListener('mousemove', this.mouseMoveEvent)
      this.$bus.$on('GLOBAL_THEME_SYSTEM', this.handleThemeChange)
    },
    beforeDestroy () {
      window.removeEventListener('mousemove', this.mouseMoveEvent)
      this.$bus.$off('GLOBAL_THEME_SYSTEM', this.handleThemeChange)
    },
    methods: {
      init () {
        // this.initBg()
        this.initSlogan()
        this.initDate()
        this.initDigitalHuman()
      },
      mouseMoveEvent (e) {
        this.mouseXY = `${e.x},${e.y}`
      },
      initDate () {
        this.currentDate = moment().format('YYYY-MM-DD')
        this.currentDay = moment().format('dddd')
      },
      // 获取人文关怀文案
      async initSlogan () {
        const { list = [] } = await this.$http('kuasheng.ksApplicationAdv.getErpHomePageCareReminder', {}, {appkey: '10184'})
        if (list.length) {
          const index = Math.floor(Math.random() * list.length)
          this.slogan = list[index].richName || list[index].name
        } else {
          this.slogan = ''
        }
      },
      async pollDigitalHuman () {
        if (this.mouseXY !== this.oldMouseXY) {
          this.oldMouseXY = this.mouseXY
          this.initDigitalHuman()
        }
      },
      async initDigitalHuman (displayDigitalHumanFlag = 0) {
        const params = displayDigitalHumanFlag === 1 ? { displayDigitalHumanFlag: 1 } : {}
        const data = await this.$http('system.homeDigitalHuman.get', params, { axios: { headers: { 'x-relet': '20' } } })
        this.digitalHuman.show = data && +data.displayDigitalHumanFlag === 1
        this.digitalHuman.code = data && data.digitalHumanCode ? data.digitalHumanCode : ''
        this.digitalHuman.enableClick = data && +data.clickFlag === 1
        // this.digitalHuman.code = 'nm-jnr-kf-m-q'
        // this.digitalHuman.enableClick = true
        this.digitalHuman.greetings = data && data.greetings ? data.greetings : this.getTimePeriodText()
      },
      handleThemeChange (theme) {
        const show = theme && +theme.displayDigitalHumanFlag === 1
        this.digitalHuman.show = show
        // 后端会根据是否显示数字人，来判断是否返回code，提升性能（用户在模块页签切到首页时如果数字人之前被隐藏，则不会返回code，导致数字人永远无法显示）
        if (show) {
          this.initDigitalHuman(1)
        }
      },
      // 获取未读消息数量
      // async getNoticeNum () {
      //   try {
      //     this.unReadNum = await this.$http('kuasheng.newsNotification.newsNoReadNum', {}, {appkey: '10184'})
      //   } catch (err) {
      //     console.error(err)
      //   } finally {
      //     this.unReadLoading = false
      //   }
      // },
      // getBgImg (theme) {
      //   return THEME_IMG_MAP[theme]
      // },
      // getInitTheme () {
      //   const obj = JSON.parse(localStorage.ERPTHEME || '{}')
      //   return obj.header || '#894fd5'
      // },
      // initBg (theme) {
      //   if (!theme) theme = this.getInitTheme()
      //   const bg = this.getBgImg(theme)
      //   this.$refs.userHeader.style.backgroundImage = `url(${bg}) `
      // },
      getTimePeriodText () {
        const hours = new Date().getHours()
        if (hours >= 6 && hours < 12) return '早上好'
        if (hours >= 12 && hours < 18) return '下午好'
        return '晚上好'
      },
      switchDigitalHuman () {
        if (!this.digitalHuman.code || !this.humanMaterialList.length) return
        const currentIndex = this.humanMaterialList.findIndex(item => item.value === this.digitalHuman.code)
        const nextIndex = currentIndex >= 0 && currentIndex < this.humanMaterialList.length - 1 ? currentIndex + 1 : 0
        const nextItem = this.humanMaterialList[nextIndex]
        if (!nextItem) return
        this.digitalHuman.code = nextItem.value
        let enableClick = false
        if (nextItem.ext) {
          try {
            const extData = JSON.parse(nextItem.ext)
            enableClick = extData && (extData.isClick === 1)
          } catch (error) {
            enableClick = false
          }
        }
        this.digitalHuman.enableClick = enableClick

        const msg = `【${nextItem.label}${enableClick ? '（含点击）' : ''}】数字人显示成功`
        this.$message.success(msg)
      },
      handleApplyClick () {
        this.$router.push('/oa/workflow/apply-pane')
      },
      handleRefresh () {
        this.$emit('refresh')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-notice-card {
  width: 100%;
  // min-height: 156px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px 12px 0 0;
  .user-header {
    position: relative;
    border-bottom: 0;
    box-sizing: border-box;
    min-height: 160px;
    padding: 20px 20px 16px 20px;
    // background: url('./images/kye.png');
    // background-position: top right;
    // background-repeat: no-repeat;
  }
  .avatar-row {
    display: flex;
    align-items: center;
    color: #1d1c23;
    font-weight: 400;
    font-size: 28px;
    line-height: 39px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: calc(100% - 122px);
    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .user-slogan {
    width: 400px;
    min-height: 18px;
    line-height: 18px;
    color: #1d1c23;
    font-weight: normal;
    margin-top: 6px;
    margin-bottom: 16px;
    font-size: 13px;
    padding-right: 100px;
    /deep/ p{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .time {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    color: #6e6b75;
    font-size: 13px;
    line-height: 18px;
    .time-line {
      margin: 0 6px;
    }
  }
  .line {
    width: 1px;
    height: 7px;
    background-color: rgba(103, 91, 235, 0.2);
  }
  .apply-box {
    display: flex;
    align-items: center;
    .apply-btn {
      display: flex;
      align-items: center;
      padding: 0 12px;
      font-size: 12px;
      font-weight: 400;
      line-height: 28px;
      height: 28px;
      color: #fff;
      border-radius: 14px;
      color: #6d2ef8;
      background: rgba(109, 46, 248, 0.07);
      cursor: pointer;
    }
    .apply-line {
      margin-left: 9px;
      margin-right: 7px;
    }
    .refresh-btn {
      display: flex;
      align-items: center;
      color: #6d2ef8;
      cursor: pointer;
      border-radius: 14px;
      padding: 0 12px;
      font-size: 12px;
      font-weight: 400;
      line-height: 28px;
      background: transparent;
      margin-left: 6px;
      &:hover {
        background: rgba(109, 46, 248, 0.07);
      }
      .layout-refresh {
        font-size: 14px;
      }
      span {
        font-size: 13px;
        margin-left: 2px;
      }
    }
  }

  .digital-human-wrap {
    position: absolute;
    right: 10px;
    bottom: 0px;
    width: 200px;
    z-index: 88;
  }
  .switch-digital-human {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 88;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/notice.vue